/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ErrorCode } from 'client-code/episode-guide';

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class EpisodeGuideError extends AppError {
    public TAG: string = 'EpisodeGuideError';

    protected title: string = Locale.getString(LocaleKeys.VOD_BROWSE_ERROR_OVERLAY_TITLE);

    public constructor(code: string, message: string, description: string) {
        super(code, message);
        this.message = message;
        this.description = description;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorCode.ApigwError:
                this.code = ErrorTypes.EPISODE_GUIDE_APIGW_ERROR_C1501;
                this.type = ErrorCode.ApigwError;
                break;
            case ErrorCode.BadRequest:
                this.code = ErrorTypes.EPISODE_GUIDE_BAD_REQUEST_C1502;
                this.type = ErrorCode.BadRequest;
                break;
            case ErrorCode.ResourceNotFound:
                this.code = ErrorTypes.EPISODE_GUIDE_RESOURCE_NOT_FOUND_C1503;
                this.type = ErrorCode.ResourceNotFound;
                break;
            case ErrorCode.InternalServerError:
                this.code = ErrorTypes.EPISODE_GUIDE_INTERNAL_SERVER_ERROR_C1504;
                this.type = ErrorCode.InternalServerError;
                break;
            default:
                this.code = ErrorTypes.EPISODE_GUIDE_UNKNOWN_ERROR_C1599;
                this.type = 'EPISODE_GUIDE_UNKNOWN_ERROR';
        }
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }
}
